namespace Matrix.Data {
    export interface EventLogRow {
        EventId?: number;
        EventType?: string;
        Message?: string;
        Action?: string;
        RowsAffected?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
    }

    export namespace EventLogRow {
        export const idProperty = 'EventId';
        export const nameProperty = 'EventType';
        export const localTextPrefix = 'Data.EventLog';
        export const deletePermission = 'NoPermission';
        export const insertPermission = 'NoPermission';
        export const readPermission = 'Read:EventLog';
        export const updatePermission = 'NoPermission';

        export declare const enum Fields {
            EventId = "EventId",
            EventType = "EventType",
            Message = "Message",
            Action = "Action",
            RowsAffected = "RowsAffected",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen"
        }
    }
}
